/* @flow */
import * as React from 'react';

import LoadingIndicator from 'components/LoadingIndicator';
import Profile from 'components/Profile';
import UsersAvatarWithText from 'users/components/UsersAvatarWithText';
import { subtextForMember } from './utils';

import type { OrganizationRole } from 'queries/__generated__/globalGQLTypes';

import './UsersProfile.scss';

export type UserProfilePartial = {
  id: number,
  uuid: string,
  name: string,
  firstName: string,
  lastName: string,
  roles: OrganizationRole[],
  grade: ?string,
};

type Props = {
  errorBanner: React.Element,
  loading: boolean,
  loaded: boolean,
  member: UserProfilePartial,
  onBackClicked?: () => void,
  onClose: () => void,
};

export default class UsersProfilePartial extends React.Component<Props> {
  renderLoadingIndicator = () => {
    if (this.props.loading) {
      return <LoadingIndicator align="center" size="small" />;
    }

    return null;
  };

  render() {
    const { onBackClicked, onClose, member, errorBanner } = this.props;

    return (
      <React.Fragment>
        <Profile
          actions={null}
          errorBanner={errorBanner}
          loadingIndicator={this.renderLoadingIndicator()}
          noteField={null}
          sections={[]}
          onBackClicked={onBackClicked}
          onChange={() => {}}
          onClose={onClose}
          header={
            <UsersAvatarWithText
              avatarSize="xxlarge"
              level="primary"
              subtext={subtextForMember(member)}
              user={member}
            />
          }
          className="UsersProfile"
        />
      </React.Fragment>
    );
  }
}
